import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { CLINsTab } from '../../CLINsLCATs/CLINsTab';
export function SourcesCLINsPage() {
    const { id } = useParams();
    if (!id) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: "p-4 sm:p-6 lg:p-8",
        children: /*#__PURE__*/ _jsx(CLINsTab, {
            projectId: id
        })
    });
}
